import React from "react";
import "assets/loader.styles.css";
import loadingGif from "assets/loading.png";
const Loader = () => {
  return (
    <div className="text-loader font-monoton flex flex-col gap-1 items-center">
      <span className="zoom-in-out-box">
        <img
          width={80}
          src={loadingGif}
          alt="loading..."
          className="opacity-[0.25]"
        />
      </span>
      <div className="text-container">
        <span className="letter">9</span>
        <span className="letter">9</span>
        <span className="letter">9</span>
        <span className="letter">9</span>

      </div>
    </div>
  );
};

export default Loader;
